export default "__VITE_ASSET__CDudaJWU__"